<template>
  <ModuleSection title="跨行汇款">
   <el-form ref="form" label-width="180px" :model="formData" :rules="rules">
     <!-- 汇款信息 -->
      <SubSection title="汇款信息" show-spread>
        <el-row>
          <el-col>
            <div style="margin-top: 20px;color: #FF2653; font-size: 14px;">{{ $t('受疫情影响，汇往中国大陆地区的款项到账时间可能延长，具体情况可咨询收款方银行。') }}</div>
          </el-col>
        </el-row>
           <el-row style="margin-top: 20px;">
              <!-- 汇款人姓名 -->
              <el-col>
                <el-form-item prop="payAccountName" :label="$t('汇款人姓名') + '：'">
                  <template>
                    <span
                      class="union-field"
                      v-text="formData.payAccountName"
                    />
                  </template>
                </el-form-item>
              </el-col>
              <!-- 汇款人地址 -->
              <el-col>
                <el-form-item prop="payAddress" :label="$t('汇款人地址') + '：'">
                  <el-input
                    class="union-field"
                    type="textarea"
                    :rows="4"
                    v-model="formData.payAddress"
                  />
                </el-form-item>
              </el-col>
              <!-- 汇款人账号 -->
              <el-col>
                <el-form-item prop="payAccount" :label="$t('汇款人账号') + '：'">
                  <el-select
                    @change="onPayAccountSelectChange"
                    class="union-field text-overcut"
                    v-model="formData.payAccount">
                     <el-option
                      v-for="item in payAccountOptions"
                      :key="item.value"
                      :label="item.label | translateFilter"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 汇款币种 -->
              <el-col>
                <el-form-item prop="currencyTypeShow" :label="$t('汇款币种') + '：'">
                  <template>
                    <span class="union-field">
                      {{ $t(formData.currencyTypeShow) }}
                    </span>
                  </template>
                </el-form-item>
              </el-col>
              <!-- 账户余额 -->
              <el-col>
                <el-form-item prop="balanceAvailable" :label="$t('账户余额') + '：'">
                  <template>
                    <span
                      class="union-field"
                      v-text="formData.balanceAvailable"
                    />
                  </template>
                </el-form-item>
              </el-col>
              <!-- 汇款金额 -->
              <el-col>
                <el-form-item prop="payAmount" :label="$t('汇款金额') + '：'">
                  <template>
                    <el-input
                      :maxlength="11"
                      class="union-field"
                      :placeholder="$t('请输入汇款金额')"
                      v-model="formData.payAmount"
                    />
                  </template>
                  <span class="union-field-extra limit-amount-label">{{ $t('单笔限额') }}：<span class="limit-amount">{{ formData.payAmountLimit }}</span> {{ $t(formData.payAmountLimitCurrencyType) }}</span>
                </el-form-item>
              </el-col>
              <!-- 费用承担方 -->
              <el-col>
                <el-form-item prop="FeeFlg" :label="$t('费用承担方') + '：'">
                  <el-select
                    class="union-field"
                    v-model="formData.FeeFlg"
                    >
                    <el-option
                      v-for="item in FeeFlgOptions"
                      :key="item.value"
                      :label="$t(item.label)"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 手续费 -->
              <el-col>
                <el-form-item prop="chargeFee" :label="$t('手续费') + '：'">
                  <template>
                    <span
                      class="union-field"
                      v-text="formData.chargeFee"
                    />
                  </template>
                  <a class="union-field-extra extra-link" target="_blank" :href="CHARGING_STANDARD">{{ $t('收费标准')}}</a>
                </el-form-item>
              </el-col>
              <!-- 汇款附言 -->
              <el-col>
                <el-form-item prop="payRemark" :label="$t('汇款附言') + '：'">
                  <template>
                    <el-input
                      :maxlength="140"
                      class="union-field"
                      :placeholder="$t('请输入字母、数字、空格或/.,?:()-+{}，不超过140个字符')"
                      v-model="formData.payRemark"
                    />
                  </template>
                </el-form-item>
              </el-col>
              <el-col>
             <!-- 汇款用途（非CNY情况） -->
              <el-col>
                <el-form-item  v-show="!showPayUseList" prop="payUseNotCNY" :label="$t('汇款用途')+ '：'">
                  <el-select
                      v-model="formData.payUseNotCNY"
                      class="union-field"
                      filterable
                      :placeholder="$t('请选择')"
                    >
                      <el-option
                        v-for="(label, value) in PURPOSE_OF_REMITTANCE"
                        :key="value"
                        :label="$t(label)"
                        :value="value"
                      ></el-option>
                    </el-select>
                </el-form-item>
              <!-- 汇款用途 -->
                <el-form-item  v-show="!showPayUseList && formData.payUseNotCNY === 'OTHERS'"  prop="payUse">
                  <template>
                    <el-input
                      :maxlength="140"
                      class="union-field"
                      :placeholder="$t('请输入字母、数字、空格或/.,?:()-+{}，不超过140个字符')"
                      v-model="formData.payUse"
                    />
                  </template>
                </el-form-item>
                <el-form-item v-show="showPayUseList" prop="payUseSelect" :label="$t('汇款用途') + '：'">
                  <template>
                    <el-select
                      class="union-field"
                      filterable
                      :placeholder="$t('请选择')"
                      v-model="formData.payUseSelect"
                    >
                      <el-option
                        v-for="item in payUseList"
                        :key="item.code"
                        :label="$t(item.name)"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              </el-col>
            </el-row>
          </SubSection>
          <!-- 收款信息 -->
          <SubSection title="收款信息" show-spread>
             <el-row style="margin-top: 20px;">
               <!-- 收款人名称 -->
               <el-col>
                 <el-form-item prop="recAccountName" :label="$t('收款人名称') + '：'">
                   <el-input
                    class="union-field"
                    :placeholder="$t('请输入字母、数字、空格或/.,?:()-+{}，不超过140个字符')"
                    v-model="formData.recAccountName"
                   />
                   <span v-if="showPayEEListDialog" class="union-field-extra">
                     <span @click="openRecPeopleDialog()" class="extral-native-btn">{{ $t('收款人名册') }}</span>
                   </span>
                 </el-form-item>
               </el-col>
               <!-- 收款人账号 -->
               <el-col>
                 <el-form-item prop="recAccount" :label="$t('收款人账号') + '：'">
                   <el-input
                    class="union-field"
                    :placeholder="$t('请输入收款人账号')"
                    v-model="formData.recAccount"
                   />
                   <span class="union-field-extra">
                    <el-tooltip :content="$t('汇往欧盟及阿联酋的跨境汇款，请填写IBAN号作为收款人帐号')">
                      <span class="icon-tips"></span>
                    </el-tooltip>
                  </span>
                 </el-form-item>

               </el-col>
               <!-- 收款人国家/地区 -->
               <el-col>
                 <el-form-item prop="recCountry" :label="$t('收款人国家/地区') + '：'">
                   <el-select
                    class="union-field"
                    filterable
                    :placeholder="$t('请选择')"
                    v-model="formData.recCountry"
                   >
                    <el-option
                      v-for="item in countryOptions"
                      :key="item.codeNum"
                      :label="item.engName"
                      :value="item.engName"
                    ></el-option>
                   </el-select>
                 </el-form-item>
               </el-col>
               <!-- 收款人地址 -->
               <el-col>
                 <el-form-item prop="bankRem" :label="$t('收款人地址') + '：'">
                   <el-input
                    class="union-field"
                    type="textarea"
                    show-word-limit
                    :maxlength="maxRecNameAndBankRemCount - formData.recAccountName.length - 3"
                    :rows="4"
                    :placeholder="$t('请输入字母或数字地址，按门牌号、街道、城市，例如 No.55 Fuxingmen Nei Street , Xicheng District , Beijing ; Number可简写为No. street可简写st.')"
                    v-model="formData.bankRem"
                   />
                 </el-form-item>
               </el-col>
               <!-- SWIFT代码 -->
               <el-col>
                 <el-form-item prop="bankSwift" :label="$t('SWIFT代码') + '：'">
                   <el-input
                    class="union-field"
                    @blur="checkExtCode()"
                    :placeholder="$t('请输入8位或11位SWIFT代码')"
                    v-model="formData.bankSwift"
                   />
                 </el-form-item>
               </el-col>
               <!-- ABA号 -->
               <el-col v-if="effects.abaCodeVisible">
                 <el-form-item prop="abaCode" :label="$t('ABA号') + '：'">
                   <el-input
                    class="union-field"
                    :maxlength="9"
                    :placeholder="$t('请输入ABA号')"
                    v-model="formData.abaCode"
                   />
                 </el-form-item>
               </el-col>
               <!-- 收款银行地区 -->
               <el-col v-if="effects.bankRegionVisible">
                 <el-form-item prop="bankRegion" :label="$t('收款银行地区') + '：'">
                   <el-select
                    class="union-field"
                    filterable
                    :placeholder="$t('请选择')"
                    v-model="formData.bankRegion"
                   >
                    <el-option
                      v-for="item in provinces"
                      :key="item"
                      :label="$t(item)"
                      :value="item"
                    ></el-option>
                   </el-select>
                 </el-form-item>
               </el-col>
               <!-- 收款银行 -->
               <el-col v-if="effects.bankVisible">
                 <el-form-item prop="bank" :label="$t('收款银行') + '：'">
                    <el-select
                    class="union-field"
                    filterable
                    :placeholder="$t('请选择')"
                    v-model="formData.bank"
                   >
                    <el-option
                      v-for="item in headOffices"
                      :key="item"
                      :label="$t(item)"
                      :value="item"
                    ></el-option>
                   </el-select>
                 </el-form-item>
               </el-col>
               <!-- 收款银行名称（中文）： -->
               <el-col v-if="effects.branchBankVisible">
                 <el-form-item prop="branchBank" :label="$t('收款银行名称（中文）') + '：'">
                    <el-select
                    class="union-field"
                    filterable
                    @change="handleBranchBankChange"
                    :placeholder="$t('请选择')"
                    v-model="formData.branchBank"
                   >
                    <el-option
                      v-for="item in chineseBankList"
                      :key="item.unionNumber"
                      :label="$t(item.bankName)"
                      :value="item.unionNumber"
                    ></el-option>
                   </el-select>
                 </el-form-item>
               </el-col>
               <!-- CNAPS号 -->
               <el-col v-if="effects.cnapsCodeVisible">
                 <el-form-item prop="cnapsCode" :label="$t('CNAPS号') + '：'">
                   <el-input
                    disabled
                    class="union-field"
                    :maxlength="12"
                    :placeholder="$t('请输入12位数字收款行大额行号CNAPS')"
                    v-model="formData.cnapsCode"
                   />
                 </el-form-item>
               </el-col>
               <!-- BSB号 -->
               <el-col v-if="effects.bsbCodeVisible">
                 <el-form-item prop="bsbCode" :label="$t('BSB号') + '：'">
                   <el-input
                    class="union-field"
                    :maxlength="6"
                    :placeholder="$t('请输入6位数字BSB号')"
                    v-model="formData.bsbCode"
                   />
                 </el-form-item>
               </el-col>
                    <!-- 收款银行名称 (英文) -->
               <el-col>
                 <el-form-item prop="recBankName" :label="$t('收款银行名称 (英文)') + '：'">
                   <el-input
                    class="union-field"
                    :placeholder="$t('请输入字母、数字、空格或/.,?:()-')"
                    v-model="formData.recBankName"
                   />
                 </el-form-item>
               </el-col>
               <!-- 收款银行国家/地区-->
               <el-col>
                 <el-form-item prop="recBankCountry" :label="$t('收款银行国家/地区') + '：'">
                   <span class="union-field">
                    {{ $t(formData.recBankCountry) }}
                   </span>
                 </el-form-item>
               </el-col>
               <!-- 收款银行地址-->
               <el-col>
                 <el-form-item prop="recBankAddress" :label="$t('收款银行地址') + '：'">
                   <el-input
                    class="union-field"
                    type="textarea"
                    show-word-limit
                    :maxlength="137"
                    :rows="4"
                    :placeholder="$t('请输入字母或数字地址，按门牌号、街道、城市，例如 No.55 Fuxingmen Nei Street , Xicheng District , Beijing ; Number可简写为No. street可简写st.')"
                    v-model="formData.recBankAddress"
                   />
                 </el-form-item>
               </el-col>
              <!-- 通知收款方-->
               <el-col>
                   <div style="display:flex; justify-content: flex-start;">
                     <el-form-item style="width: 300px" :label="$t('通知收款方') + '：'" prop="noticyAreaCode">
                      <el-select v-model="formData.noticyAreaCode">
                      <el-option
                        v-for="item in phoneCodeList"
                        :key="item.countryName"
                        :label="'+' + item.countryCode"
                        :value="'+' + item.countryCode">
                        <span style="float: left">{{ '+' + item.countryCode }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ $t(item.countryName) }}</span>
                    </el-option>
                      </el-select>
                    </el-form-item>
                 <el-form-item prop="noticyPhone" label-width="10px" style="width: 400px">
                      <el-input
                        show-word-limit
                        :maxlength="11"
                        :placeholder="$t('请输入收款方负责人手机号')"
                        v-model="formData.noticyPhone"
                      />
                 </el-form-item>
                   </div>
               </el-col>
               <el-col>
                 <el-form-item prop="noticyEmail">
                      <el-autocomplete
                       class="union-field"
                        show-word-limit
                        :maxlength="128"
                        :trigger-on-focus="false"
                        @blur="handleEmailBlur"
                        :fetch-suggestions="queryEmailSuggestions"
                        :placeholder="$t('请输入收款方负责人邮箱')"
                        v-model="formData.noticyEmail"
                      />
                 </el-form-item>
                 <p class="noticy-tips">
                   {{ $t('资金从我行汇出成功后，将通知收款方，可不填') }}
                 </p>
               </el-col>
             </el-row>
          </SubSection>
          <SubSection title="代理行信息(选填)" desc="（以下信息有助于解付路径长的汇款及时到账）">
            <el-row style="margin-top: 20px;">
              <!-- 代理行SWIFT代码 -->
              <el-col v-if="effects.agentBankSwiftVisible">
                <el-form-item prop="agentBankSwift" :label="$t('代理行SWIFT代码') + '：'">
                  <el-input
                    class="union-field"
                    :placeholder="$t('请输入8位或11位SWIFT代码')"
                    v-model="formData.agentBankSwift"
                  />
                </el-form-item>
              </el-col>

              <!-- 代理行ABA号 -->
              <el-col v-if="effects.agentAbaCodeVisible">
                <el-form-item prop="agentAbaCode" :label="$t('代理行ABA号') + '：'">
                  <el-input
                    class="union-field"
                    :maxlength="9"
                    :placeholder="$t('请输入9位ABA号')"
                    v-model="formData.agentAbaCode"
                  />
                </el-form-item>
              </el-col>
              <!-- 代理行名称 -->
              <el-col>
                <el-form-item prop="agentRecBankName" :label="$t('代理行名称') + '：'">
                  <el-input
                    class="union-field"
                    :placeholder="$t('请输入字母、数字、空格或/.,?:()-+{}，不超过140个字符')"
                    v-model="formData.agentRecBankName"
                  />
                </el-form-item>
              </el-col>
              <!-- 代理行国家/地区 -->
              <el-col>
                <el-form-item prop="agentRecBankCountry" :label="$t('代理行国家/地区') + '：'">
                  <span class="union-field">
                    {{ $t(formData.agentRecBankCountry) }}
                   </span>
                </el-form-item>
              </el-col>
              <!-- 代理行地址 -->
              <el-col>
                <el-form-item prop="agentRecBankAddress" :label="$t('代理行地址') + '：'">
                  <el-input
                    class="union-field"
                    type="textarea"
                    :rows="4"
                    :placeholder="$t('请输入字母或数字地址，按门牌号、街道、城市，例如 No.55 Fuxingmen Nei Street , Xicheng District , Beijing ; Number可简写为No. street可简写st.')"
                    v-model="formData.agentRecBankAddress"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <p style="display:flex;margin-top: 40px; margin-left: 177px">
                  <el-button class="w140-btn" type="info" @click="resetFields()">{{ $t('重置') }}</el-button>
                  <el-button class="w140-btn" @click="submitToNext()">{{ $t('下一步') }}</el-button>
                </p>
              </el-col>
            </el-row>
          </SubSection>
      </el-form>
      <!-- 收款人名册 -->
      <PayEEListDialog  rec-bank-type="1" payee-type="0" :visible="payEEListDialogVisible" @cancel="payEEListDialogVisible = false" @updatePayeeInfo="onPayeeInfoSelect" />
  </ModuleSection>
</template>

<script>
import { forOwn, without } from 'lodash-es'
import { Message } from 'element-ui'
import ModuleSection from '@/components/container/ModuleSection'
import SubSection from '@/components/container/SubSection'
import { genRequiredRule, genRegTestRule, genFormatValidateRule, genRegTestRuleReverse } from '@/utils/form/genrules'
import PayEEListDialog from '../../components/PayEEListDialog'
import commonApi from '@/api/common'
import api from '../../api/interbank-transfers'
import { CHARGING_STANDARD, CURRENCY_TYPE, EMPTY_STRING, SIGN_DOT, SIGN_BAR, NULL, STRING_TRUE, STRING_FALSE, COUNTRY_LIST, SIGN_SLASH, PATTERN1, PATTERN2, PATTERN4, PATTERN6, CODE_MAP, PATTERN7, PURPOSE_OF_REMITTANCE } from '../../components/constants'

function transformObj2SelectOptionsArray (source) {
  const options = []
  forOwn(source, (label, value) => {
    options.push({
      label,
      value
    })
  })
  return options
}

export default {
  name: 'Step1Cache',
  components: {
    ModuleSection,
    SubSection,
    PayEEListDialog
  },
  activated () {
    const { routeType } = this.$route.params
    if (routeType === 'NO_CACHE') {
      this.resetFields()
      this.onInit()
    } else if (routeType === 'CACHE') {
      ;
    } else {
      this.onInit()
    }
  },
  data () {
    return {
      CHARGING_STANDARD,
      CURRENCY_TYPE,
      EMPTY_STRING,
      SIGN_DOT,
      SIGN_BAR,
      SIGN_SLASH,
      NULL,
      STRING_TRUE,
      STRING_FALSE,
      PURPOSE_OF_REMITTANCE,
      maxRecNameAndBankRemCount: 140,
      payAccountOptions: [],
      FeeFlgOptions: [],
      countryOptions: [],
      provinces: [],
      headOffices: [],
      chineseBankList: [],
      // 手机区号列表
      phoneCodeList: [],
      // 收款人名册入口是否渲染出来
      showPayEEListDialog: true,
      effects: {
        // 控制abaCode显示隐藏
        abaCodeVisible: false,
        // 收款银行地区显示隐藏
        bankRegionVisible: false,
        // 收款银行显示隐藏
        bankVisible: false,
        // 收款银行名称（中文）显示隐藏
        branchBankVisible: false,
        // CNAPS号显示隐藏
        cnapsCodeVisible: false,
        // 代理行ABA号显示隐藏
        agentAbaCodeVisible: false,
        // BSB号显示隐藏
        bsbCodeVisible: false,
        // 代理行swift代码显示隐藏
        agentBankSwiftVisible: false
      },
      // 收款人名册弹出框控制
      payEEListDialogVisible: false,
      formData: {
        /* -------------付款信息--------------- */
        // 汇款人姓名
        payAccountName: EMPTY_STRING,
        // 汇款人地址
        payAddress: EMPTY_STRING,
        // 汇款人账号
        payAccount: EMPTY_STRING,
        // 汇款币种
        currencyType: EMPTY_STRING,
        // 是否加入收款人名册
        addPayBookFlag: '0',
        // 汇款币种页面展示
        currencyTypeShow: EMPTY_STRING,
        // 单笔限额
        payAmountLimit: EMPTY_STRING,
        // 单笔限额币种
        payAmountLimitCurrencyType: EMPTY_STRING,
        // 账户余额
        balanceAvailable: EMPTY_STRING,
        // 汇款金额
        payAmount: EMPTY_STRING,
        // 费用承担方 默认为 'S' 共同-SHA
        FeeFlg: 'S',
        // 手续费
        chargeFee: EMPTY_STRING,
        // 汇款附言
        payRemark: EMPTY_STRING,
        // 汇款用途
        payUse: EMPTY_STRING,
        // 汇款用途(非CNY账户)
        payUseNotCNY: EMPTY_STRING,
        payUseSelect: EMPTY_STRING,
        /* -------------收款信息--------------- */
        // 收款人名称
        recAccountName: EMPTY_STRING,
        // 收款人账号
        recAccount: EMPTY_STRING,
        // 收款银行名称（中文）
        branchBank: EMPTY_STRING,
        // 收款人国家/地区
        recCountry: EMPTY_STRING,
        // 收款人地址
        bankRem: EMPTY_STRING,
        // SWIFT代码
        bankSwift: EMPTY_STRING,
        // ABA Code
        abaCode: EMPTY_STRING,
        // 收款银行名称 (英文)
        recBankName: EMPTY_STRING,
        // cnapsCode
        cnapsCode: EMPTY_STRING,
        // bsbCode
        bsbCode: EMPTY_STRING,
        // 收款银行国家/地区
        recBankCountry: EMPTY_STRING,
        // 收款银行地址
        recBankAddress: EMPTY_STRING,
        // 通知汇款人手机区号
        noticyAreaCode: '+86',
        // 通知汇款人手机号
        noticyPhone: EMPTY_STRING,
        // 通知汇款人邮箱
        noticyEmail: EMPTY_STRING,
        /* -------------代理行信息--------------- */
        // 代理行SWIFT代码
        agentBankSwift: EMPTY_STRING,
        // agentAbaCode
        agentAbaCode: EMPTY_STRING,
        // 代理行名称
        agentRecBankName: EMPTY_STRING,
        // 代理行ABA号
        agentRecBankAba: EMPTY_STRING,
        // 代理行国家/地区
        agentRecBankCountry: EMPTY_STRING,
        // 代理行地址
        agentRecBankAddress: EMPTY_STRING,

        /* -------------分支逻辑字段---------------- */
        // 收款银行地区
        bankRegion: EMPTY_STRING,
        // 收款银行
        bank: EMPTY_STRING
      },

      // 汇款附言为选择弹框
      showPayUseList: false,
      payUseList: Object.keys(this.$_params.payUseList).map(item => {
        const name = this.$_params.payUseList[item]
        return {
          code: item,
          name
        }
      })
    }
  },
  methods: {
    onInit () {
      this.initPaymentInfo()
      this.initSelectOptions()
      this.initSomeParmasByOtherPagesTransfer()
      this.initChinaBankRegions()
    },

    // 初始化汇款人信息（姓名和地址）
    initPaymentInfo () {
      api.companyDetailManage({ currentBusinessCode: '10700700' }).then(res => {
        this.formData.payAddress = res.address
        this.formData.payAccountName = res.customerNameCN
      }).catch(console.error)
    },
    // 初始化页面Select选项
    initSelectOptions () {
      // 设置国家列表
      this.countryOptions = COUNTRY_LIST
      // 转换汇款人账号options
      this.payAccountOptions = transformObj2SelectOptionsArray(this.$_params.getSessionAccountSelect_obj('ALL', true, 2))
      // 转换费用承担方options
      this.FeeFlgOptions = transformObj2SelectOptionsArray(this.$_params.chargeFee)
      // 通知收款方 手机区号options
      commonApi.getCountryAreaCodeList().then(res => {
        this.phoneCodeList = res
      }).catch(console.error)
    },
    initChinaBankRegions () {
      api.getRegionAndBank().then(res => {
        this.provinces = res.provinces
        this.headOffices = res.headOffices
      }).catch(console.error)
    },
    resetFields () {
      this.$refs.form.resetFields()
      this.effects = {
        // 控制abaCode显示隐藏
        abaCodeVisible: false,
        // 收款银行地区显示隐藏
        bankRegionVisible: false,
        // 收款银行显示隐藏
        bankVisible: false,
        // 收款银行名称（中文）显示隐藏
        branchBankVisible: false,
        // CNAPS号显示隐藏
        cnapsCodeVisible: false,
        // 代理行ABA号显示隐藏
        agentAbaCodeVisible: false,
        // BSB号显示隐藏
        bsbCodeVisible: false,
        // 代理行swift代码显示隐藏
        agentBankSwiftVisible: false
      }
      this.onInit()
    },
    // 处理中国银行选择
    handleBranchBankChange (value) {
      this.formData.cnapsCode = value
    },

    queryEmailSuggestions (queryString, pipe) {
      const suffixes = [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@139.com',
        '@gmail.com',
        '@sina.com',
        '@yeah.net',
        '@sohu.com',
        '@hotmail.com',
        '@sina.cn',
        '@yahoo.com',
        '@foxmail.com'
      ]
      const mentionCheckReg = /@/
      if (mentionCheckReg.test(queryString)) {
        const [before, after] = queryString.split('@')
        pipe(suffixes.filter(suffix => suffix.includes(after)).map(suffix => ({
          value: before + suffix
        })))
      } else {
        pipe(suffixes.map(suffix => ({
          value: queryString + suffix
        })))
      }
    },
    // 清除报错信息
    clearValidateErrors (field) {
      this.$refs.form.clearValidate(field)
    },

    handleEmailBlur () {
      // 延时为了解决输入建议选择时，校验的还是输入值的问题
      setTimeout(() => {
        this.$refs.form.validateField(['noticyEmail'])
      }, 200)
    },

    initSomeParmasByOtherPagesTransfer () {
      // 这段代码需等其他页面完成后再写
      const { reponseData } = this
      if (reponseData.accountNo) {
        // 处理首页跳转的逻辑
        // 根据传过来的账户号以及businesscode查询该账号相关的数据
        const matchedPayAccount = this.payAccountOptions.find(item => item.value.includes(reponseData.accountNo))
        if (matchedPayAccount) {
          this.formData.payAccount = matchedPayAccount.value
        } else {
          this.formData.payAccount = reponseData.accountNo
        }
        this.onPayAccountSelectChange(this.formData.payAccount)
        this.formData.payAccountName = this.$_params.getAccountName(reponseData.accountNo)
        this.formData.currencyTypeShow = this.$_params.getCurrencyType(reponseData.accountNo)
        this.formData.currencyType = this.formData.payAccount.split(SIGN_BAR)[1]
        // 币种为人民币的时候，汇款用途展示选择框
        if (this.formData.currencyType === CURRENCY_TYPE.CNY) {
          this.showPayUseList = true
        }
      } else if (reponseData.recAccount) {
        // 此处的值为从收款人名册过来的数据，应将传过来的数据反显在收款人处
        api.customerPayeeInfo({
          searchAccount: reponseData.recAccount,
          currentBusinessCode: '10200500'
        }).then(res => {
          this.formData.recAccount = reponseData.recAccount
          this.showPayEEListDialog = false
          this.formData.recAccountName = reponseData.recAccountName
          this.formData.bankSwift = reponseData.bankSwift
          this.formData.bankRem = reponseData.agencyBankAddress
          this.formData.recAddress = res.recAddress
          this.formData.recBankAddress = res.recBankAddress
          this.formData.recBankCountry = res.recBankCountry
          this.formData.recBankName = res.recBankName
          this.formData.recCountry = res.recCountry
          this.formData.agentBankSwift = res.agentBankSwift
          this.formData.agentRecBankAddress = res.agentRecBankAddress
          this.formData.agentRecBankCountry = res.agentRecBankCountry
          this.formData.agentRecBankName = res.agentRecBankName
        })
      }
    },
    async onPayeeInfoSelect (info) {
      this.payEEListDialogVisible = false
      const res = await api.getCustomerPayeeDetail({ recAccount: info.recAccount })
      this.formData.recAccountName = info.recAccountName
      this.formData.recAccount = info.recAccount
      this.formData.bankSwift = info.bankSwift
      this.formData.bankRem = info.agencyBankAddress
      // 收款人国家
      this.formData.recCountry = res.recCountry
      // 收款银行名称
      this.formData.recBankName = res.recBankName
      this.formData.recBankAddress = res.recBankAddress
      // 收款银行国家
      this.formData.recBankCountry = res.recBankCountry
      this.checkExtCode()
      this.$refs.form.validateField(['recAccountName', 'recAccount', 'bankSwift', 'bankRem', 'recCountry', 'recBankName', 'recBankAddress', 'recBankCountry'])
    },

    checkNewPayAccount (value) {
      api.accountStatusCheck({ accountNo: value.split(SIGN_BAR)[0], currentBusinessCode: '10200010' }).then(res => {
        if (res.canTransfer === STRING_FALSE) {
          this.$talert('汇款账号开通当日不能进行跨行转账操作，请使用其他账号跨行汇款或明日再操作。', '系统提示')
          this.formData.payAccount = EMPTY_STRING
        }
      }).catch(console.error)
    },
    // 检查是否符合MSB规则
    checkMsb (next, self) {
      const payAccount = self.formData.payAccount.split(SIGN_BAR)[0].toUpperCase()
      const recAccount = self.formData.recAccount.split(SIGN_SLASH)[0].toUpperCase()
      const bankSwift = self.formData.bankSwift.toUpperCase()
      if ((bankSwift.indexOf('CBLBPRSJ') > -1 || bankSwift.indexOf('WPACAU2S') > -1) && payAccount && recAccount) {
        api.canTransfer({
          ownAcc: payAccount,
          otherAcc: recAccount
        }).then(res => {
          if (!res.result) {
            self.formData.recAccount = EMPTY_STRING
            self.formData.bankSwift = EMPTY_STRING
            next(new Error(res.message))
          }
          next()
        }).catch(console.error)
      } else {
        next()
      }
    },
    checkExtCode () {
      const self = this
      const payAcc = self.formData.payAccount.split(SIGN_BAR)
      const bankSwift56 = self.formData.bankSwift.trim().toUpperCase().substring(4, 6)
      const currencyType = payAcc[1]
      const accountType = payAcc[4]
      // 检查是够支持当前收款银行所在的国家和地区
      if (/MSB/.test(accountType) && bankSwift56 === 'CN') {
        self.formData.bankSwift = EMPTY_STRING
        self.formData.recBankCountry = EMPTY_STRING
        self.$talert('暂不支持此收款银行所在国家/地区', '系统提示')
      }
      if (bankSwift56 === 'US' && currencyType === 'USD') {
        self.effects.abaCodeVisible = true
        self.effects.bankRegionVisible = false
        self.formData.bankRegion = EMPTY_STRING
        self.effects.bankVisible = false
        self.formData.bank = EMPTY_STRING
        self.effects.branchBankVisible = false
        self.formData.branchBank = EMPTY_STRING
        self.effects.cnapsCodeVisible = false
        self.formData.cnapsCode = EMPTY_STRING
        self.effects.bsbCodeVisible = false
        self.formData.bsbCode = EMPTY_STRING
      } else if (bankSwift56 === 'CN') {
        self.effects.abaCodeVisible = false
        self.formData.abaCode = EMPTY_STRING
        self.effects.bankRegionVisible = true
        self.effects.bankVisible = true
        self.effects.branchBankVisible = true
        self.effects.cnapsCodeVisible = true
        self.effects.bsbCodeVisible = false
        self.formData.bsbCode = EMPTY_STRING
      } else if (bankSwift56 === 'AU') {
        self.effects.abaCodeVisible = false
        self.formData.abaCode = EMPTY_STRING
        self.effects.bankRegionVisible = false
        self.formData.bankRegion = EMPTY_STRING
        self.effects.bankVisible = false
        self.formData.bank = EMPTY_STRING
        self.effects.branchBankVisible = false
        self.formData.branchBank = EMPTY_STRING
        self.effects.cnapsCodeVisible = false
        self.formData.cnapsCode = EMPTY_STRING
        self.effects.bsbCodeVisible = true
      } else {
        self.effects.abaCodeVisible = false
        self.formData.abaCode = EMPTY_STRING
        self.effects.bankRegionVisible = false
        self.formData.bankRegion = EMPTY_STRING
        self.effects.bankVisible = false
        self.formData.bank = EMPTY_STRING
        self.effects.branchBankVisible = false
        self.formData.branchBank = EMPTY_STRING
        self.effects.cnapsCodeVisible = false
        self.formData.cnapsCode = EMPTY_STRING
        self.effects.bsbCodeVisible = false
        self.formData.bsbCode = EMPTY_STRING
        self.formData.abaCode = EMPTY_STRING
      }
    },
    openRecPeopleDialog () {
      if (this.formData.payAccount.trim().length) {
        this.payEEListDialogVisible = true
      } else {
        this.$talert('请选择付款账号！', '系统提示')
      }
    },
    getAccountBalance (accountNo, currencyType) {
      api.accountBalanceQuery({
        accountNo,
        currentBusinessCode: '10100000'
      }).then(res => {
        if (res.ec !== '0') {
          this.formData.balanceAvailable = EMPTY_STRING
          this.$talert(`${res.em}`, '系统提示')
        } else {
          const balanceAvailable = parseFloat(res.balanceAvailable)
          const currencyType = res.currencyType
          if (currencyType === CURRENCY_TYPE.JPY || currencyType === CURRENCY_TYPE.KRW) {
            // 显示到个位
            this.formData.balanceAvailable = this.$_format.toCashWithComma_grb(balanceAvailable)
          } else {
            // 显示到分位
            this.formData.balanceAvailable = this.$_format.toCashWithComma(balanceAvailable)
          }
          this.formData.currencyTypeShow = this.$_params.getDisplay('GRB_CURRENCY_TYPE', currencyType)
          this.formData.currencyType = currencyType
          // 兴业swift优化：币种为人民币的时候，汇款用途展示选择框
          if (currencyType === 'CNY') {
            this.showPayUseList = true
            this.formData.payUse = EMPTY_STRING
          } else {
            if (this.formData.payUseNotCNY !== 'OTHERS') {
              this.formData.payUse = this.formData.payUseNotCNY
            }
            this.formData.payUseSelect = EMPTY_STRING
            this.showPayUseList = false
          }
        }
      }).catch(console.error)
      api.queryTransferLimit({ accountNo }).then(res => {
        const showTheUnit = [CURRENCY_TYPE.JPY, CURRENCY_TYPE.KRW].includes(currencyType)
        // 显示到个位
        if (showTheUnit) {
          this.formData.payAmountLimit = this.$_format.toCashWithComma_grb(res.limitSingle)
        } else {
          // 显示到分位
          this.formData.payAmountLimit = this.$_format.toCashWithComma(res.limitSingle)
        }
        this.formData.payAmountLimitCurrencyType = res.cnCryType
      }).catch(console.error)
    },
    onPayAccountSelectChange (value) {
      if (!value) return false
      this.formData.payUse = EMPTY_STRING
      this.formData.payUseNotCNY = EMPTY_STRING
      this.checkNewPayAccount(value)
      if (this.formData.payAccountName !== EMPTY_STRING) {
        this.formData.payAccountName = EMPTY_STRING
      }
      if (this.formData.balanceAvailable !== EMPTY_STRING) {
        this.formData.balanceAvailable = EMPTY_STRING
      }
      if (this.formData.payAmount !== EMPTY_STRING) {
        this.formData.payAmount = EMPTY_STRING
      }
      if (this.formData.chargeFee !== EMPTY_STRING) {
        this.formData.chargeFee = EMPTY_STRING
      }
      const [accountNo, currencyType] = value.split(SIGN_BAR)
      if (accountNo !== EMPTY_STRING) {
        // 设置汇款币种，账户余额以及单笔限制金额和币种
        this.getAccountBalance(accountNo, currencyType)
        // 设置汇款人姓名
        this.formData.payAccountName = this.$_params.getAccountName(accountNo)
      } else {
        if (this.formData.currencyTypeShow !== EMPTY_STRING) {
          this.formData.currencyTypeShow = EMPTY_STRING
        }
        if (this.formData.currencyType !== EMPTY_STRING) {
          this.formData.currencyType = EMPTY_STRING
        }
        this.payAmountLimit = EMPTY_STRING
        this.payAmountLimitCurrencyType = EMPTY_STRING
      }
      const accountType = this.formData.payAccount.split(SIGN_BAR)[4]

      if (accountType === 'MSBC') {
        this.effects.agentBankSwiftVisible = false
        this.effects.agentAbaCodeVisible = true
        this.formData.agentRecBankCountry = EMPTY_STRING
        this.formData.agentRecBankName = EMPTY_STRING
        this.formData.agentRecBankAddress = EMPTY_STRING
      } else {
        this.effects.agentBankSwiftVisible = true
        this.effects.agentAbaCodeVisible = false
        this.formData.agentAbaCode = EMPTY_STRING
        this.formData.agentRecBankCountry = EMPTY_STRING
      }
      this.checkExtCode()
    },

    submitToNext () {
      const allRuleKeys = Object.keys(this.rules)
      const toBeRemoveKeys = ['agentBankSwift', 'agentAbaCode', 'agentRecBankName', 'currencyType', 'agentRecBankAba', 'recBankCountry', 'balanceAvailable', 'chargeFee', 'agentRecBankCountry', 'agentRecBankAddress']
      // 进行币种判断，然后进行是否展示判断
      if (this.formData.currencyType === 'CNY') {
        toBeRemoveKeys.push('payUseNotCNY')
        toBeRemoveKeys.push('payUse')
      } else {
        if (this.formData.payUseNotCNY === 'OTHERS') {
          toBeRemoveKeys.push('payUseNotCNY')
        }
        toBeRemoveKeys.push('payUseSelect')
      }
      forOwn(this.effects, (value, key) => {
        if (!value) {
          toBeRemoveKeys.push(key.slice(0, -7))
        }
      })
      const toBeValidateFields = without(allRuleKeys, ...toBeRemoveKeys)
      Promise.all(toBeValidateFields.map(field => {
        const promise = new Promise((resolve, reject) => {
          this.$refs.form.validateField(field, function (errorMessage) {
            if (errorMessage) {
              reject(new Error(errorMessage))
            } else {
              resolve(true)
            }
          })
        })
        return promise
      })).then(_ => {
        this.submit()
      })
    },
    submit () {
      const payAccountName = this.formData.payAccountName.toUpperCase().trim()
      const payAccountAliasName = this.$_params.getAccountAliasName(this.formData.payAccount).trim()
      const payAddress = this.formData.payAddress.toUpperCase().replace(/\s/g, ' ').trim()
      const payAccount = this.formData.payAccount.split(SIGN_BAR)[0].toUpperCase().trim()
      const currencyType = this.formData.currencyType.toUpperCase().trim()
      const balanceAvailable = this.$_format.removeComma(this.formData.balanceAvailable).trim()
      const payAmount = this.$_format.removeComma(this.formData.payAmount).trim()
      const FeeFlg = this.formData.FeeFlg.toUpperCase().trim()
      const chargeFee = this.$_format.removeComma(this.formData.chargeFee).trim()
      const payRemark = this.formData.payRemark.toUpperCase().trim()
      const payUse = currencyType === 'CNY' ? this.formData.payUseSelect.toUpperCase().trim() : this.formData.payUse.toUpperCase().trim()
      const recAccountName = this.formData.recAccountName.toUpperCase().trim()
      const recAccount = this.formData.recAccount.split(SIGN_SLASH)[0].toUpperCase().trim()
      const recCountry = this.formData.recCountry.toUpperCase().trim()
      const bankRem = this.formData.bankRem.toUpperCase().replace(/\s/g, ' ').trim()
      const bankSwift = this.formData.bankSwift.toUpperCase().trim()
      const recBankName = this.formData.recBankName.toUpperCase().trim()
      const recBankCountry = this.formData.recBankCountry.toUpperCase().trim()
      const recBankAddress = this.formData.recBankAddress.toUpperCase().replace(/\s/g, ' ').trim()
      const agentBankSwift = this.formData.agentBankSwift.toUpperCase().trim()
      const agentRecBankName = this.formData.agentRecBankName.toUpperCase().trim()
      const agentRecBankCountry = this.formData.agentRecBankCountry.toUpperCase().trim()
      const agentRecBankAddress = this.formData.agentRecBankAddress.toUpperCase().replace(/\s/g, ' ').trim()
      const abaCode = this.formData.abaCode.toUpperCase().trim()
      const addPayBookFlag = this.formData.addPayBookFlag
      const cnapsCode = this.formData.cnapsCode.toUpperCase().trim()
      const bsbCode = this.formData.bsbCode.toUpperCase().trim()
      const agentAbaCode = this.formData.agentAbaCode.toUpperCase().trim()

      if ((currencyType === CURRENCY_TYPE.JPY || currencyType === CURRENCY_TYPE.KRW) && (parseInt(payAmount) !== payAmount)) {
        return this.$talert('日元和韩元账户转账金额只能为整数，请重新输入', '系统提示')
      }
      api.accLimitQueryGRB({
        payAmount,
        payAccount,
        currencyType,
        currentBusinessCode: '10200010'
      }).then(() => {
        const { noticyPhone, noticyEmail, noticyAreaCode } = this.formData
        sessionStorage.removeItem('noticyPhone')
        sessionStorage.removeItem('noticyEmail')
        sessionStorage.setItem('noticyAreaCode', noticyAreaCode)
        if (noticyPhone) {
          sessionStorage.setItem('noticyPhone', noticyPhone)
        }
        if (noticyEmail) {
          sessionStorage.setItem('noticyEmail', noticyEmail)
        }
        this.$router.push({
          name: 'InterBankOutwardStep2',
          query: {
            payAccountName,
            payAccountAliasName,
            payAddress,
            payAccount,
            currencyType,
            balanceAvailable,
            payAmount,
            FeeFlg,
            chargeFee,
            payRemark,
            payUse,
            recAccountName,
            recAccount,
            recCountry,
            bankRem,
            bankSwift,
            recBankName,
            recBankCountry,
            recBankAddress,
            agentBankSwift,
            agentRecBankName,
            agentRecBankCountry,
            agentRecBankAddress,
            abaCode,
            addPayBookFlag,
            cnapsCode,
            bsbCode,
            agentAbaCode
          }
        })
      }).catch(res => {
        Message.closeAll()
        if (CODE_MAP[res.ec]) {
          this.$talert(CODE_MAP[res.ec], '系统提示')
        } else {
          this.$talert(`${res.em}`, '系统提示')
        }
      })
    }
  },
  computed: {
    rules () {
      const self = this
      const payAmountValidator = function (_, value, next) {
        const payAmount = self.$_format.removeComma(value)
        const n = (payAmount.split(SIGN_DOT)).length - 1
        // 也就是如果汇款金额为空,手续费为空
        if (n > 1 || isNaN(payAmount) || parseInt(payAmount) === '0' || payAmount === EMPTY_STRING || payAmount === NULL) {
          self.formData.chargeFee = EMPTY_STRING
          next()
        }
        const payAccount = self.formData.payAccount.split(SIGN_BAR)[0]
        const payAmountCopied = self.formData.payAmount
        const FeeFlg = self.formData.FeeFlg
        const currencyType = self.formData.currencyType
        const balanceVal = self.$_format.removeComma(self.formData.balanceAvailable)
        if ([payAccount, payAmountCopied, FeeFlg].every(value => !self.$_format.isEmpty(value))) {
          api.queryChargeFee({
            recBankType: '1',
            currentBusinessCode: '10200300',
            systemCode: '1',
            payAmount,
            payAccount,
            channel: '1103',
            feeType: '002',
            currencyType,
            FeeFlg
          }).then(res => {
            const chargeFee = res.chargeFee
            // 日元韩元不显示保留整数
            if (currencyType === CURRENCY_TYPE.JPY || currencyType === CURRENCY_TYPE.KRW) {
              self.formData.chargeFee = self.$_format.toCashWithComma_grb(chargeFee)
            } else {
              self.formData.chargeFee = self.$_format.toCashWithComma(chargeFee)
            }
            if (FeeFlg === 'B') {
              if (parseFloat(payAmount) > parseFloat(balanceVal)) {
                self.formData.payAmount = EMPTY_STRING
                next(new Error(self.$t('账户余额不足')))
              }
              if (parseFloat(chargeFee) > parseFloat(payAmount)) {
                self.formData.payAmount = EMPTY_STRING
                next(new Error(self.$t('手续费大于转账金额')))
              }
            } else {
              if (parseFloat(payAmount) + parseFloat(chargeFee) > parseFloat(balanceVal)) {
                self.formData.payAmount = EMPTY_STRING
                next(new Error(self.$t('转账金额加手续费不能超过账户余额')))
              }
            }
            self.formData.payAmount = self.$_format.toCashWithComma(self.formData.payAmount)
            next()
          }).catch(res => {
            next(new Error(EMPTY_STRING))
            self.$talert(`${res.em}`, '系统提示')
          })
        }
      }

      const msbValidator = function (_, value, next) {
        self.checkMsb(next, self)
      }
      return {
      // 汇款人姓名
        payAccountName: [
          genRequiredRule()
        ],
        // 汇款人地址
        payAddress: [
          genRequiredRule('请输入汇款人地址'),
          genFormatValidateRule(self.$_format.hasChineseChar, '汇款人地址不能包含中文'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        // 汇款人账号
        payAccount: [
          genRequiredRule('请选择汇款人账号', 'change'),
          {
            validator: msbValidator,
            trigger: 'change'
          }
        ],
        // 汇款币种
        currencyType: [],
        // 账户余额
        balanceAvailable: [],
        // 汇款金额
        payAmount: [
          genRequiredRule('请输入汇款金额'),
          {
            trigger: 'blur',
            validator: payAmountValidator
          }],
        // 费用承担方 和汇款金额使用同一校验规则
        FeeFlg: [
          genRequiredRule('请选择费用承担方', 'change')
          // 这里暂时去掉，等费用承担方有多个的时候再启动以下校验，校验记得不要取value，取payAmount的值
          // {
          //   trigger: 'blur',
          //   validator: payAmountValidator
          // }
        ],
        // 手续费
        chargeFee: [],
        // 汇款附言
        payRemark: [
          genRequiredRule('请输入汇款附言'),
          genFormatValidateRule(self.$_format.hasChineseChar, '汇款附言不能包含中文'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        payUseNotCNY: [
          genRequiredRule('请选择汇款用途', 'change')
        ],
        // 汇款用途
        payUse: [
          genRequiredRule('请输入汇款用途'),
          genFormatValidateRule(self.$_format.hasChineseChar, '汇款用途不能包含中文'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        payUseSelect: [
          genRequiredRule('请选择汇款用途', 'change')
        ],
        /* -------------收款信息--------------- */
        // 收款人名称
        recAccountName: [
          genRequiredRule('请输入收款人名称'),
          genFormatValidateRule(self.$_format.hasChineseChar, '收款人名称不能包含中文'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        // 收款人账号
        recAccount: [
          genRequiredRule('请输入收款人账号'),
          genFormatValidateRule(self.$_format.hasChineseChar, '收款人账号不能包含中文'),
          genRegTestRule(PATTERN2, '您输入的收款账号格式不正确，请您输入数字、字母或空格'),
          {
            validator: msbValidator,
            trigger: 'blur'
          }
        ],
        // 收款人国家/地区
        recCountry: [
          genRequiredRule('请选择收款人国家/地区', 'change'),
          genFormatValidateRule(self.$_format.hasChineseChar, '收款人国家不能包含中文')
        ],
        // 收款人地址
        bankRem: [
          genRequiredRule('收款人地址不能为空'),
          genRegTestRuleReverse(PATTERN7, '收款人地址不能输入中文标点符号'),
          genRegTestRule(PATTERN1, '收款人地址格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        // SWIFT代码
        bankSwift: [
          genRequiredRule('swift代码不能为空'),
          genFormatValidateRule(self.$_format.hasChineseChar, 'SWIFT代码不能包含中文'),
          genRegTestRule(PATTERN4, '您输入的SWIFT代码不符合格式'),
          {
            validator: function (_, value, next) {
              const bankSwift56 = value.trim().toUpperCase().substring(4, 6)
              api.checkBankSwift({
                swiftCode: bankSwift56
              }).then(res => {
                if (res.status === 'OK') {
                  self.formData.recBankCountry = res.countryName
                  next()
                } else if (res.status === 'UNDER_SANCTION') {
                  self.formData.bankSwift = EMPTY_STRING
                  next(new Error('暂不支持此收款银行所在国家/地区'))
                } else {
                  self.formData.bankSwift = EMPTY_STRING
                  self.formData.recBankCountry = EMPTY_STRING
                  next(new Error('银行SWIFT代码输入有误，请重新输入'))
                }
              }).catch(next)
            },
            trigger: 'blur'
          },
          {
            validator: msbValidator,
            trigger: 'blur'
          }
        ],
        // aba码
        abaCode: [
          genRequiredRule('请输入ABA码'),
          genFormatValidateRule(self.$_format.hasChineseChar, 'ABA码不能包含中文', 'trigger'),
          genRegTestRule(PATTERN6, '您输入的格式不正确'),
          {
            trigger: 'blur',
            min: 9,
            message: self.$t('未查询到ABA代码，请您重新核实或联系客服')
          },
          {
            trigger: 'blur',
            validator: function (rule, value, next) {
              api.checkABACode({
                routing: value
              }).then(res => {
                if (res.length === 0) {
                  self.formData.abaCode = EMPTY_STRING
                  self.formData.recBankName = EMPTY_STRING
                  self.formData.recBankAddress = EMPTY_STRING
                  next(new Error(self.$t('未查询到ABA代码，请您重新核实或联系客服')))
                } else {
                  const data = res[0]
                  self.formData.recBankName = data.bankName
                  self.formData.recBankAddress = data.address
                  next()
                }
              }).catch(console.error)
            }
          }
        ],
        // 收款银行名称 (英文)
        recBankName: [
          genRequiredRule('收款银行名称不能为空'),
          genRegTestRule(PATTERN1, '您输入的字符格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        cnapsCode: [
          genFormatValidateRule(self.$_format.hasChineseChar, 'CNAPS码不能包含中文')
        ],
        bsbCode: [
          genRequiredRule('请输入BSB号'),
          genFormatValidateRule(self.$_format.hasChineseChar, 'BSB码不能包含中文'),
          genRegTestRule(/^\d{6}$/, '您输入的格式不正确，请输入6位数字')
        ],
        // 收款银行国家/地区
        recBankCountry: [],
        // 收款银行地址
        recBankAddress: [
          genRequiredRule('收款银行地址不能为空'),
          genRegTestRuleReverse(PATTERN7, '收款银行地址不能输入中文标点符号'),
          genRegTestRule(PATTERN1, '收款银行地址格式不正确，请输入字母、数字、空格或/.,?:()-+{}')
        ],
        // 通知汇款人手机区号
        noticyAreaCode: [],
        // 通知汇款人手机号
        noticyPhone: [
          {
            trigger: 'blur',
            validator (_, value, next) {
              if (!value.trim()) {
                next()
                return
              }
              if (self.formData.noticyAreaCode === '+86') {
                const reg = /^(13[0-9]|17[0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/
                if (!reg.test(value)) {
                  next(self.$t('请输入正确格式的手机号码'))
                } else {
                  next()
                }
              } else {
                if (!/\d{5,11}/.test(value)) {
                  next(self.$t('请输入正确格式的手机号码'))
                } else {
                  next()
                }
              }
            }
          }
        ],
        // 通知汇款人邮箱
        noticyEmail: [{
          trigger: [''],
          validator (_, value, next) {
            if (!value.trim()) {
              next()
              return
            }
            const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
            if (!emailReg.test(value)) {
              next(self.$t('请填写正确的邮箱'))
            } else {
              next()
            }
          }
        }],
        /* -------------代理行信息--------------- */
        // 代理行SWIFT代码
        agentBankSwift: [
          genFormatValidateRule(self.$_format.hasChineseChar, '代理行SWIFT代码不能包含中文'),
          genRegTestRule(PATTERN4, '您输入的代理行SWIFT代码不符合格式', 'blur', true),
          {
            validator: function (_, value, next) {
              if (!value.trim()) {
                return next()
              }
              const agentBankSwift56 = value.trim().toUpperCase().substring(4, 6)
              api.checkBankSwift({
                swiftCode: agentBankSwift56
              }).then(res => {
                if (res.status === 'OK') {
                  self.formData.agentRecBankCountry = res.countryName
                  next()
                } else if (res.status === 'UNDER_SANCTION') {
                  self.formData.agentBankSwift = EMPTY_STRING
                  next(self.$t('暂不支持此收款银行所在国家/地区'))
                } else {
                  self.formData.agentBankSwift = EMPTY_STRING
                  self.formData.agentRecBankCountry = EMPTY_STRING
                  next(self.$t('银行SWIFT代码输入有误，请重新输入'))
                }
              }).catch(next)
            },
            trigger: 'blur'
          }
        ],

        agentAbaCode: [
          genFormatValidateRule(self.$_format.hasChineseChar, 'ABA码不能包含中文'),
          genRegTestRule(PATTERN6, '您输入的代理行ABA码格式不正确', 'blur', true),
          {
            trigger: 'blur',
            validator: function (_, value, next) {
              if (!value.trim()) {
                return next()
              }
              api.checkABACode({
                routing: value
              }).then(res => {
                if (res.length === 0) {
                  self.formData.agentAbaCode = EMPTY_STRING
                  self.formData.agentRecBankName = EMPTY_STRING
                  self.formData.agentRecBankAddress = EMPTY_STRING
                  next(new Error(self.$t('未查询到ABA代码，请您重新核实或联系客服')))
                } else {
                  const data = res[0]
                  self.formData.agentRecBankName = data.bankName
                  self.formData.agentRecBankAddress = data.address
                  self.formData.agentRecBankCountry = self.$t('美国')
                }
              }).catch(console.error)
            }
          }
        ],
        // 代理行名称
        agentRecBankName: [
          genFormatValidateRule(self.$_format.hasChineseChar, '代理行收款银行地址不能包含中文'),
          genRegTestRuleReverse(PATTERN7, '代理行收款银行地址不能输入中文标点符号'),
          genRegTestRule(PATTERN1, '代理行收款银行地址格式不正确，请输入字母、数字、空格或/.,?:()-+{}', 'blur', true)
        ],
        // 代理行ABA号
        agentRecBankAba: [],
        // 代理行国家/地区
        agentRecBankCountry: [],
        // 代理行地址
        agentRecBankAddress: [],
        branchBank: [
          genRequiredRule('请选择', 'change')
        ],
        bankRegion: [
          genRequiredRule('请选择', 'change')
        ],
        bank: [
          genRequiredRule('请选择', 'change')
        ]
      }
    },
    // 兼容老版传值reponseData
    reponseData () {
      return this.$route.query
    },
    cnapsCodeParam () {
      return { province: this.formData.bankRegion, headOffice: this.formData.bank }
    }
  },
  watch: {
    cnapsCodeParam (newValue) {
      if (newValue.province && newValue.headOffice) {
        api.getBranchBank(newValue).then(res => {
          this.chineseBankList = res
        }).catch(console.error)
      }
    },
    'formData.payUseNotCNY' (newValue) {
      if (newValue !== 'OTHERS') {
        this.formData.payUse = newValue
      } else {
        this.formData.payUse = EMPTY_STRING
      }
    }
  }
}
</script>

<style scoped lang="less">
.union-field {
  display: inline-block;
  color: #5A607F;
  width: 520px;
}
.union-field-extra {
  margin-left: 20px;
  position: relative;
}
.icon-tips {
  position: absolute;
  top: 0;
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(~assets/image/icons/icon_input_tips.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.extra-link {
  color: #4A6AFF;
}
.extral-native-btn {
  color: #4A6AFF;
  cursor: pointer;
}
.limit-amount-label {
  color: #A1A7C4;
}
.limit-amount {
  color: #5A607F;
  font-weight: bold;
}
.w140-btn {
  min-width: 140px;
  height: 40px;
}
.noticy-tips {
  color: #a1a7c4;
  margin-left:180px;
  font-size: 14px;
  font-weight: 300;
  padding-top: 5px;
}
</style>
